import { h, render, Fragment } from "preact";
import { convertSchemaToHtml } from "@thebeyondgroup/shopify-rich-text-renderer";

export default function RichText({ schema, className }) {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: convertSchemaToHtml(schema.replace(/\\n/g, "<br>")),
      }}
    ></div>
  );
}
